export const STORAGE_KEYS = {
  USER_TOKEN: 'token',
}
